import React, { useState } from 'react';
import { useAsync } from 'react-use';
import PropTypes from 'prop-types';
import { algoliaClient, INDEX_COLLECTIONS } from 'src/lib/algolia';
import { CollectionListContainer } from 'src/components/ProductListingPage/productList';

const FeatureCollection = ({ hitsPerPage, enableCarousel, handle, title, collectionDefaultIndex, boostUrl, isFromHomePage }) => {
  const [defaultIndex, setDefaultIndex] = useState(() => (
    isFromHomePage ? collectionDefaultIndex || 'default' : null
  ));
  useAsync(async () => {
    // no fetch for home page
    if (isFromHomePage) return;
    const currentCollectionIndex = algoliaClient.initIndex(INDEX_COLLECTIONS);
    const response = await currentCollectionIndex.search('', {
      filters: `handle:${handle} AND isOnline:true AND blockOnSiteSearch:false`
    });

    const { hits } = response;
    if (hits?.length > 0) {
      setDefaultIndex(`${hits[0].sortBy}`);
    }
  }, [handle, isFromHomePage]);
  if (!defaultIndex) return null;
  return (
    <div className="container is-clipped feature-collection">
      {(title) && (
        <div className="home-section-header">
          {title && <h2 className="heading5 is-uppercase">{title}</h2>}
        </div>
      )}
      <CollectionListContainer
        enableCarousel={enableCarousel}
        showShopAll={false}
        collection={
          {
            handle,
            title,
            collectionDefaultIndex: defaultIndex,
            boostUrl,
            hitsPerPage
          }
        }
      />
    </div>
  );
};

FeatureCollection.propTypes = {
  hitsPerPage: PropTypes.number.isRequired,
  enableCarousel: PropTypes.bool.isRequired,
  handle: PropTypes.string.isRequired,
  title: PropTypes.string,
  collectionDefaultIndex: PropTypes.string,
  boostUrl: PropTypes.string,
  isFromHomePage: PropTypes.bool
};

FeatureCollection.defaultProps = {
  title: null,
  collectionDefaultIndex: null,
  boostUrl: null,
  isFromHomePage: false
};

export { FeatureCollection };
